import { Grid } from '@material-ui/core'
import { SppWLFilter } from 'components/SPP/SppWLFilter/SppWLFilter'
import { SppWLTable } from 'components/SPP/SppWLTable/SppWLTable'

export const SppWlList = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <SppWLFilter />
      </Grid>
      <Grid item xs={12} style={{ margin: '16px 0 80px 0' }}>
        <SppWLTable />
      </Grid>
    </Grid>
  )
}
